import React, { useEffect, useState } from "react";
import "../style/agent.css";
import { Link, useNavigate } from "react-router-dom";
import { API_Path, ApiBaseUrl } from "../Const";
import { GetApi, PostApi } from "../api/api-service";
import EmailAgentModal from "../components/modal/EmailAgentModal";
import AgentFilter from "../components/filter/AgentFilter";
import ContectModal from "../components/modal/ContectModal";
import TruAgentModal from "../components/modal/TruAgentModal";
import QualityLister from "../components/modal/QualityLister";
import ResponsiveBrokerModal from "../components/modal/ResponsiveBrokerModal";
import noDataFound from "../images/noDataFound.png";
import AgenciesLoader from "../components/loader/AgenciesLoader";
import NewCommonPagination from "../components/NewCommonPagination";
import developerLogo from "../images/developer.svg";
import { convertToSlug } from "../components/CommonFun";
import { REMail } from "../components/icons/IconSvg";

export default function AgenciesList() {
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(true);
    const [agencyData, setAgencyData] = useState([]);
    const [emailModalShow, setEmailModalShow] = useState(false);
    const [phoneModalShow, setPhoneModalShow] = useState({ show: false, data: "" });
    const [currentAgyPage, setCurrentAgyPage] = useState(1);
    const [pageAgySize, setPageAgySize] = useState(20);
    const [totalAgyPages, setTotalAgyPages] = useState(1);
    const [qualityShow, setQualityShow] = useState(false);
    const [truAgentShow, setTruAgentShow] = useState(false);
    const [resAgentShow, setResAgentShow] = useState(false);
    const [agenciesName, setAgenciesName] = useState([]);
    const [serLoader, setSerLoader] = useState(false);
    const [btnLoader, setBtnLoader] = useState({ serach: false, reset: false });
    const [agenciesFilter, setAgenciesFilter] = useState({
        type: "Agencies",
        name: [],
        languages: [],
        contacts: [],
        specialities: "",
        country: "",
        state: "",
        city: "",
        locality: "",
        searchValue: "",
    });

    useEffect(() => {
        fatchAgenciesName();
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const parsedFilters = {
            type: "Agencies",
            name: params.get("name")?.split(",") || [],
            languages: params.get("languages")?.split(",") || [],
            specialities: params.get("specialities") || "",
            searchValue: params.get("searchValue") || "",
            currentPageA: params.get("page") || 1,
        };
        setAgenciesFilter(parsedFilters);
        fetchAgencyData(parsedFilters?.currentPageA, parsedFilters);
    }, []);

    const fatchAgenciesName = async () => {
        try {
            const res = await GetApi(API_Path.AgenciesDetails + "/Name");
            if (res?.data?.success) {
                let data = res.data.data;
                const formattedNames = data.map((name) => ({ name: name.trim(), slug: convertToSlug(name) }));
                setAgenciesName(formattedNames);
            }
        } catch (error) {
            console.error("Error fetching area units:", error);
        }
    };

    const handleModalHide = () => setEmailModalShow(false);
    const fetchAgencyData = async (page, item) => {
        let data = {
            name: item?.name?.length > 0 ? item?.name : null,
            languages: item?.languages?.length > 0 ? item?.languages : null,
            contacts: item?.contacts?.length > 0 ? item?.contacts : null,
            country: item?.country ? item?.country : null,
            state: item?.state ? item?.state : null,
            city: item?.city ? item?.city : null,
            locality: item?.locality ? item?.locality : null,
            searchValue: item?.searchValue ? item?.searchValue : null,
        };
        let cleanedData = Object.fromEntries(
            Object.entries(data).filter(([key, value]) => value !== null && value !== undefined && value !== "" && value !== 0 && !(Array.isArray(value) && value.length === 0))
        );
        try {
            setIsLoader(true);
            let res = await PostApi(API_Path.AgenciesDetails + `/pagination?pageNumber=${page}&pageSize=${pageAgySize}`, { data: cleanedData });
            if (res && res.data.success) {
                setCurrentAgyPage(res.data.currentPage);
                setPageAgySize(res.data.pageSize);
                setTotalAgyPages(res.data.totalPages);
                setAgencyData(res.data.data);
            }
            setBtnLoader({ serach: false, reset: false });
            setIsLoader(false);
        } catch (error) {
            setBtnLoader({ serach: false, reset: false });
            setIsLoader(false);
        }
    };
    const tableAgency = (page) => fetchAgencyData(page, agenciesFilter);
    const handlePhoneModalHide = () => setPhoneModalShow({ ...phoneModalShow, show: false });
    const filterCallBack = (option) => setAgenciesFilter(option);
    const handlesearch = () => {
        setBtnLoader({ serach: true, reset: false });
        navigate(buildSearchUrl());
        fetchAgencyData(1, agenciesFilter);
    };
    const handleReset = () => {
        navigate("/find-agencies");
        let data = { type: "Agencies", name: [], languages: [], contacts: [], specialities: "", country: "", state: "", city: "", locality: "", searchValue: "" };
        setAgenciesFilter(data);
        setBtnLoader({ serach: false, reset: true });
        fetchAgencyData(1, data);
    };
    const handleTruAgentClose = () => setTruAgentShow(false);
    const handleQualityClose = () => setQualityShow(false);
    const handleResAgentClose = () => setResAgentShow(false);
    const loaders = Array.from({ length: 28 });
    const buildSearchUrl = () => {
        let url = "/find-agencies/search";
        let first = true;
        const add = (key, value) => {
            if (!value || (Array.isArray(value) && value.length === 0)) return;
            url += `${first ? "?" : "&"}${key}=${encodeURIComponent(Array.isArray(value) ? value.join(",") : value)}`;
            first = false;
        };
        add("name", agenciesFilter.name);
        add("languages", agenciesFilter.languages);
        add("specialities", agenciesFilter.specialities);
        add("searchValue", agenciesFilter.searchValue);
        return url;
    };

    return (
        <>
            <div className="property-dropdown">
                <div className="container">
                    <div className="hero-dropdown-sec ps-0">
                        <div className="agencies-dropdown">
                            {/* <div className="agent-main-dropdown agencies-dropdown"> */}
                            <AgentFilter name="agencies" filterData={agenciesFilter} filterCallBack={filterCallBack} data={agencyData} aData={agenciesName} />
                            <div className="mb-2">
                                <button className="button reset_btn me-2" onClick={handleReset} disabled={btnLoader.reset}>
                                    Reset
                                </button>
                                <button className="button" onClick={handlesearch} disabled={btnLoader.serach}>
                                    Search
                                    {btnLoader.serach && <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="agent-profile-sec">
                <div className="container">
                    {isLoader ? (
                        <div className="agent-profile-inner">
                            <div className="row">
                                {loaders.map((_, index) => (
                                    <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                                        <div className="agent-card-details">
                                            <div className="agent-card">
                                                <AgenciesLoader />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <>
                            {agenciesFilter.type === "Agencies" &&
                                (agencyData.length > 0 ? (
                                    <>
                                        <div className="agent-profile-inner">
                                            <div className="row">
                                                {agencyData.map((item, i) => (
                                                    <div className="col-lg-3 col-md-4 col-sm-6" key={i}>
                                                        <div className="agent-card-details">
                                                            <div className="agent-card">
                                                                <Link to={`/agencies/${item?.slug}_${item?.uId}`} title={item.name}>
                                                                    <div className="agencies-card-inner">
                                                                        <div className="card_img agy_card_img">
                                                                            <img
                                                                                src={item.logoPath && item.logoPath !== "" ? ApiBaseUrl + "/" + item.logoPath : developerLogo}
                                                                                alt={item.name}
                                                                                loading="lazy"
                                                                                onError={({ currentTarget }) => {
                                                                                    currentTarget.onerror = null;
                                                                                    currentTarget.src = `${developerLogo}`;
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="agent_card_content">
                                                                            <h2 className="agent-name">{item.name}</h2>
                                                                            {/* {item?.agencyStats?.propertyCount && ( */}
                                                                            <div className="agent_property_name">
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="16"
                                                                                    height="16"
                                                                                    fill="currentColor"
                                                                                    className="bi bi-house-door-fill"
                                                                                    viewBox="0 0 16 16"
                                                                                >
                                                                                    <path d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5" />
                                                                                </svg>
                                                                                <p>{item?.agencyStats?.propertyCount || 0} Properties</p>
                                                                            </div>
                                                                            {/* )} */}
                                                                            <div className="agent_area">
                                                                                <p className="d-block desktop_description desktop_description_trim">
                                                                                    <span>Service Areas : </span>
                                                                                    <bdi>{item?.serviceAreas}</bdi>
                                                                                </p>
                                                                                <div
                                                                                    className="agent-actions-btn"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        e.preventDefault();
                                                                                        setEmailModalShow(true);
                                                                                    }}
                                                                                >
                                                                                    <button>
                                                                                        <REMail /> Email
                                                                                        {/* <MdMail /> Email */}
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            {/* <div className="agent-details">
                                                                <p>Properties : </p>
                                                                <span>14</span>
                                                            </div>
                                                            <div className="agent-details">
                                                                <p>Location : </p>
                                                                <span>{item.state}</span>
                                                            </div> */}
                                                                            {/* <div className="agent-actions-btn">
                                                                <button
                                                                    onClick={(e) => {
                                                                        setEmailModalShow(true);
                                                                        e.stopPropagation();
                                                                    }}
                                                                >
                                                                    Contant Us
                                                                </button>
                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <NewCommonPagination
                                            currentPage={currentAgyPage}
                                            pageSize={pageAgySize}
                                            totalPages={totalAgyPages}
                                            tableCallBack={tableAgency}
                                            data={buildSearchUrl()}
                                            // queryParams={queryParams}
                                        />
                                    </>
                                ) : (
                                    <div className="content_notfound">
                                        <img src={noDataFound} alt="No results matching your search" />
                                        <h3>No results matching your search.</h3>
                                    </div>
                                ))}
                        </>
                    )}
                </div>
            </div>

            {emailModalShow && <EmailAgentModal show={emailModalShow} onHide={handleModalHide} type="agency" title="For inquiries, contact the agency." />}
            {phoneModalShow.show && <ContectModal show={phoneModalShow.show} onHide={handlePhoneModalHide} data={phoneModalShow.data} />}
            {truAgentShow && <TruAgentModal show={truAgentShow} onHide={handleTruAgentClose} />}
            {qualityShow && <QualityLister show={qualityShow} onHide={handleQualityClose} />}
            {resAgentShow && <ResponsiveBrokerModal show={resAgentShow} onHide={handleResAgentClose} />}
        </>
    );
}
